<template>
  <v-sheet class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10">
    <v-row>
      <v-col cols="12">
        <header-medium :text="$t('Authenticate.Title')" />
      </v-col>
    </v-row>
    <v-row justify="space-around">
      <v-col cols="12">
        <v-alert class="multi-line" :color="mainColor" text type="info"> {{ $t("info_certificate_missing") }} </v-alert>
      </v-col>
    </v-row>
    <v-row justify="space-around">
      <v-col lg="5" sm="12" class="text-left">
        <v-card align-center class="d-flex mx-auto flex-column" height="100%">
          <div class="d-flex align-center justify-center text-center">
            <v-card-title min-height="200" style="height: 200px">
              <v-img class="logo_size" src="../../assets/img/AusweisApp_Bildmarke_transparent.png" />
            </v-card-title>
          </div>
          <v-card-text class="text-left">
            <p class="text-h4 text--primary text-center ">AusweisApp</p>
            <p>{{ $t("Authenticate.info_text_ausweisapp") }}</p>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      <v-icon>mdi-cellphone-key</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.ausweisapp_running") }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-icon>mdi-phone</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.smartphone") }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-icon>mdi-card-account-details-outline</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.id_card_eid") }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-icon>mdi-clock-outline</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.qes_cert_duration") }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions class="mb-1 mt-auto">
            <custom-button :disabled="disabled" @click="startOdis" :text="$t('Authenticate.identify_with_ausweisapp')" />
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col lg="5" sm="12" class="text-left">
        <v-card align-center class="d-flex mx-auto flex-column" height="100%" >
          <div class="d-flex align-center justify-center text-center">
            <v-card-title min-height="200" style="height: 200px">
              <v-img class=logo_width src="../../assets/img/Nect_Logo.svg" />
            </v-card-title>
          </div>
          <v-card-text class="pb-5 text-left" :height="cardHeight-200">
            <p class="text-h4 text--primary text-center ">Nect</p>
            <p>{{ $t("Authenticate.info_text_nect") }}</p>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      <v-icon>mdi-phone</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.smartphone") }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-icon>mdi-card-account-details-outline</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.nect_cards") }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-icon>mdi-clock-outline</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.qes_cert_duration_nect") }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions class="mb-1 mt-auto">
            <custom-button :disabled="disabled" @click="startNect" :text="$t('Authenticate.identify_with_nect')" />
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" class="text-right">
        <custom-button :disabled="disabled"  @click="showOtherOptions = !showOtherOptions" :text="$t('Authenticate.showFurtherOptions')" />
      </v-col>
      <v-col v-if="showOtherOptions" lg="5" sm="12" class="text-left">
        <v-card align-center class="d-flex mx-auto flex-column" height="100%">
          <div class="d-flex align-center justify-center text-center">
            <v-card-title min-height="200" style="height: 200px">
              <v-img class=logo_width src="../../assets/img/SIGN8_Personalident.png" />
            </v-card-title>
          </div>
          <v-card-text class="pb-5" >
            <p class="text-h4 text--primary pb-2 text-center " v-text="$t('Authenticate.personal_ident')"></p>
            <p>{{ $t("Authenticate.info_text_personal_ident") }}</p>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      <v-icon>mdi-phone</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.smartphone") }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-icon>mdi-card-account-details-outline</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.id_card") }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-icon>mdi-clock-outline</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.qes_cert_duration") }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions class="mb-1 mt-auto">
            <custom-button :disabled="disabled" @click="startPersonalIdent"
              :text="$t('Authenticate.identify_with_personal_ident')" />
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col v-if="showOtherOptions" lg="5" sm="12" class="text-left">
        <v-card align-center class="d-flex mx-auto flex-column" height="100%">
          <div class="d-flex align-center justify-center text-center">
            <v-card-title min-height="200" style="height: 200px">
              <v-img class=logo_size src="../../assets/img/TRUST_Logo.png" />
            </v-card-title>
          </div>
          <v-card-text class="text-left" :height="cardHeight-200">
            <p class="text-h4 text--primary pb-2 text-center " v-text="$t('Authenticate.existingSignature')"></p>
            <p>{{ $t("Authenticate.info_text_existing_signature") }}</p>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      <v-icon>mdi-certificate</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.info_text_existing_signature_requirement") }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-icon>mdi-clock-outline</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.qes_cert_duration") }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions class="mb-1 mt-auto">
            <custom-button :disabled="disabled" @click="startExistingSignature"
              :text="$t('Authenticate.identify_with_existing_signature')" />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="pt-5" dense v-if="!mobile">
      <v-col cols="12" sm="4" class="text-left">
        <custom-button :disabled="disabled" :text="$t('Navigation.cancel_workflow')" color="red" @click="cancel()"></custom-button>
      </v-col>
      <v-col cols="12" sm="8" class="text-right">
        <custom-button :disabled="disabled" :text="$t('DetailsPage.labels.previous')" @click="nextPage(2)"></custom-button>
      </v-col>
    </v-row>
    <v-row v-if="mobile">
      <v-col cols="12">
        <custom-button :disabled="disabled" block :text="$t('Navigation.cancel_workflow')" color="red" @click="cancel()"></custom-button>
      </v-col>
    </v-row>
    <v-row v-if="mobile">
      <v-col cols="12">
        <custom-button :disabled="disabled" block :text="$t('DetailsPage.labels.previous')" @click="nextPage(2)"></custom-button>
      </v-col>
    </v-row>

    <v-dialog v-model="loadingDialog" persistent max-width="460">
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("Authenticate.ausweisapp_redirecting_title") }}
        </v-card-title>
        <v-card-text>
          <p>{{ $t("Authenticate.ausweisapp_open_hint") }}</p>
          <div class="d-flex justify-center my-5">
            <div class="half-circle-spinner">
              <div class="circle circle-1"></div>
              <div class="circle circle-2"></div>
            </div>
          </div>
          <p class="text--secondary text-center mb-0">
            {{ $t("Authenticate.ausweisapp_redirect_wait") }}
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>
<script>
import CustomButton from "../../components/ui/input/CustomButton.vue";
import InfoAlert from "../../components/ui/other/InfoAlert.vue";
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import i18n from "@/i18n";
import cookie from "vue-cookies";
import { log } from "@/helpers/logger";

export default {
  name: "qes-identify",
  title: i18n.t("Authenticate.Title"),
  components: {
    HeaderMedium,
    CustomButton,
    InfoAlert,
  },
  data() {
    return {
      cardCount: 4,
      cardHeight: "500px",
      isMobile: false,
      mainColor: this.$vuetify.theme.themes.light.primary,
      workflow: null,
      showOtherOptions: false,
      loadingDialog: false,
      iframe: {
        src: "",
      },
      xhttp: null
    };
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  created() {
    this.$emit("step", 4);
    this.workflow = this.currentWorkflow;
    this.color = this.$vuetify.theme.themes.light.primary;
    this.$store.commit("set_loading", false);
    this.isMobile = this.detectMobile()
  },
  computed: {
    disabled() {
      return this.$store.state.loading;
    },
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
    currentFiles() {
      return this.$store.state.data.files;
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    detectMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    alert(msg) {
      this.$store.commit("ui/set_notification", {
        display: true,
        code: msg,
        alertClass: "red",
      });
      return false;
    },
    cancel() {
      this.$emit("refuse", true);
    },
    nextPage() {
      this.$store.state.auth.workflow = this.workflow;
      this.$router.push("/workflow/" + this.currentWorkflow.workflow_id + "/" + this.currentWorkflow.signer_id + "/documents");
      this.$store.commit("set_loading", true);
    },
    checkAusweisApp() {
      return new Promise((resolve) => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => {
          controller.abort();
          resolve(false);
        }, 1500);
        fetch("http://127.0.0.1:24727/eID-Client?Status", {
          mode: "no-cors",
          signal: controller.signal,
        })
          .then(() => {
            clearTimeout(timeoutId);
            resolve(true);
          })
          .catch(() => {
            clearTimeout(timeoutId);
            resolve(false);
          });
      });
    },
    async startOdis() {
      cookie.set("workflow_id", this.workflow.workflow_id, 60 * 30);
      cookie.set("signer_id", this.workflow.signer_id, 60 * 30);
      cookie.set("signer_type", this.workflow.signer_type, 60 * 30);
      this.loadingDialog = true;

      if (!this.isMobile) {
        const ausweisAppAvailable = await this.checkAusweisApp();
        if (!ausweisAppAvailable) {
          this.loadingDialog = false;
          log("QesIdentify.startOdis() - AusweisApp eID-Client not reachable on 127.0.0.1:24727", "error");
          this.alert(this.$t("Authenticate.ausweisapp_not_running"));
          return;
        }
      }

      this.$store
        .dispatch("data/startOdis")
        .then((res) => {
          if (!res) {
            this.loadingDialog = false;
            this.alert(this.$t("Authenticate.ausweisapp_start_failed"));
            return;
          }
          window.location.href = res;
        })
        .catch((err) => {
          this.loadingDialog = false;
          log("QesIdentify.startOdis() - " + err, "error");
          this.alert(this.$t("Authenticate.ausweisapp_start_failed"));
        });
    },
    startExistingSignature() {
      cookie.set("workflow_id", this.workflow.workflow_id, 60 * 30);
      cookie.set("signer_id", this.workflow.signer_id, 60 * 30);
      cookie.set("signer_type", this.workflow.signer_type, 60 * 30);
      this.$router.push("/qualifiedSignature/form");
    },
    startNect() {
      cookie.set("signer_id", this.workflow.signer_id, 60 * 30);
      cookie.set("signer_type", this.workflow.signer_type, 60 * 30);
      this.$store.dispatch("data/startNect", this.workflow).then((res) => {
        window.location.href = res.nect_url;
      });
    },
    startPersonalIdent() {
      window.location.href = "https://sign8.eu";
    },
  },
};
</script>
<style scoped>
@media only screen and (max-width: 600px) {
  .logo_size {
    width: 100px;
    height: 100px;
  }

  .logo_width {
    width: 150px;
  }
}

@media only screen and (min-width: 600px) {
  .logo_size {
    width: 150px;
    height: 150px;
  }

  .logo_width {
    width: 200px;
  }
}

.multi-line {
  white-space: pre-line;
}

.half-circle-spinner,
.half-circle-spinner * {
  box-sizing: border-box;
}

.half-circle-spinner {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  position: relative;
}

.half-circle-spinner .circle {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: calc(60px / 10) solid transparent;
}

.half-circle-spinner .circle.circle-1 {
  border-top-color: #1e6569;
  animation: half-circle-spinner-animation 1s infinite;
}

.half-circle-spinner .circle.circle-2 {
  border-bottom-color: #1e6569;
  animation: half-circle-spinner-animation 1s infinite alternate;
}

@keyframes half-circle-spinner-animation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
